import React, { useEffect, useState } from 'react';

interface MobileFixWrapperProps {
  children: React.ReactNode;
}

const MobileFixWrapper: React.FC<MobileFixWrapperProps> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (isMobile) {
    // עטוף את כל האפליקציה בדיב עם עדיפה על CSS
    return (
      <div style={{
        width: '100%',
        maxWidth: '100vw',
        overflowX: 'hidden',
        position: 'relative'
      }}>
        <style>{`
          html, body, #root {
            width: 100% !important;
            max-width: 100vw !important;
            overflow-x: hidden !important;
          }
          
          body * {
            max-width: 100vw !important;
            box-sizing: border-box !important;
          }
          
          .container, .section-container, section, div {
            max-width: 100vw !important;
            box-sizing: border-box !important;
          }
        `}</style>
        {children}
      </div>
    );
  }

  return <>{children}</>;
};

export default MobileFixWrapper;